<template lang="pug">
v-app
  Menu(:drawer="drawer")
  v-app-bar(app dense)
    v-app-bar-nav-icon(@click.stop="drawer = !drawer")
    v-toolbar-title Hey

  v-content
    v-container(v-if="loading")
      v-progress-circular( indeterminate color="primary" )
      span Loading, please wait...
    v-container(v-else)
      router-view
  Snackbar
</template>

<script>
import { mapState } from "vuex";

import Menu from "@/views/Menu";
import Snackbar from "@/components/Snackbar";

export default {
  data() {
    return {
      drawer: true,
      snackMessage: ""
    };
  },
  components: { Menu, Snackbar },
  computed: mapState(["loading", "user"])
};
</script>
